import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Film, Tv2, Radio, Users, CreditCard, Tag, TrendingUp } from "lucide-react";

export default function AdminDashboard() {
  const [stats, setStats] = useState({});

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
  }, []);

  const cards = [
    { label: "Total Users", key: "users", icon: Users, color: "text-blue-400" },
    { label: "Movies", key: "movies", icon: Film, color: "text-[#E50914]" },
    { label: "Series", key: "series", icon: Tv2, color: "text-purple-400" },
    { label: "Episodes", key: "episodes", icon: Tv2, color: "text-yellow-400" },
    { label: "Live Channels", key: "channels", icon: Radio, color: "text-green-400" },
    { label: "Active Subs", key: "subscriptions", icon: CreditCard, color: "text-cyan-400" },
    { label: "Categories", key: "categories", icon: Tag, color: "text-orange-400" },
  ];

  return (
    <div data-testid="admin-dashboard">
      <div className="mb-8">
        <span className="text-xs font-bold text-[#E50914] uppercase tracking-[0.3em]">Overview</span>
        <h1 className="text-4xl font-black tracking-tighter" style={{ fontFamily: "Outfit" }}>Dashboard</h1>
        <p className="text-[#999] mt-1">A live snapshot of your streaming empire.</p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 mb-8">
        {cards.map((c) => (
          <div key={c.key} className="bg-[#0d0d0d] border border-white/5 rounded-xl p-5 hover:border-[#E50914]/30 transition" data-testid={`stat-${c.key}`}>
            <div className="flex items-center justify-between mb-3">
              <c.icon className={c.color} size={22} />
              <TrendingUp className="text-[#444]" size={14} />
            </div>
            <div className="text-3xl font-black tracking-tighter" style={{ fontFamily: "Outfit" }}>{stats[c.key] ?? "—"}</div>
            <div className="text-xs text-[#888] uppercase tracking-wider mt-1">{c.label}</div>
          </div>
        ))}
      </div>
      <div className="bg-[#0d0d0d] border border-white/5 rounded-xl p-6">
        <h2 className="text-lg font-bold mb-3" style={{ fontFamily: "Outfit" }}>Quick Tips</h2>
        <ul className="text-sm text-[#aaa] space-y-2">
          <li>• Use the sidebar to manage your library: Movies, Series, Live TV channels, Users, Subscriptions, and Categories.</li>
          <li>• Add featured content on home using the <span className="text-[#E50914]">"Featured"</span> toggle when editing a movie or series.</li>
          <li>• Mark kids-safe content with the kids flag to make it appear in Kids Mode.</li>
        </ul>
      </div>
    </div>
  );
}
